export enum SidenavMenuStates {
  STANDARD = 'STANDARD',
  SMALL_ICONS = 'SMALL_ICONS',
  LARGE_ICONS = 'LARGE_ICONS',
  HIDDEN = 'HIDDEN'
}